/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function RolesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    uiGridConstants: JS5Object,
    BreadcrumbService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    RolesService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {};
    const getData = () => {
        this.loadingIndicator.show = true;
        RolesService.getRole($routeParams.id).then((role: JS5Object) => {
            RolesService.originalEditData = _.cloneDeep(role);
            this.editData = role;
            this.gridOptions.data = _.toArray(role.aliases);
            if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                BreadcrumbService.addBreadcrumb({
                    name: 'Edit Role',
                    location: '/system/properties/search',
                    params: {
                        tab: 'Roles',
                        subTab: this.editData.type
                    }
                });
            }
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    const saveHandler = () => {
        _.set(this.editData, 'aliases', _.toArray(this.gridOptions.data));
        _.forEach(_.get(this.editData, 'aliases'), (alias: JS5Object) => {
            _.unset(alias, 'edited');
        });
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewRole();
        }
        else {
            updateRole();
        }
    };
    const updateRole = () => {
        RolesService.updateRole(this.editData).then((role: JS5Object) => {
            RolesService.originalEditData = _.cloneDeep(role);
            this.editData = role;
            this.editorForm.$setPristine();
            this.gridApi.selection.clearSelectedRows();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewRole = () => {
        if (this.editData.type !== 'Audio') {
            _.unset(this.editData, 'dvsFlag');
        }
        RolesService.createRole(this.editData).then((role: JS5Object) => {
            $route.updateParams({id: role.id});
            this.gridApi.selection.clearSelectedRows();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const addAliasHandler = (selectedPartners: Array<JS5Object>) => {
        let originalGridDataSize = _.size(this.gridOptions.data);
        let selectedAliases = new Array<JS5Object>();
        selectedPartners.forEach((selectedPartner: JS5Object) => {
            selectedAliases.push({
                alias: '',
                edited: true,
                partner: selectedPartner
            });
        });
        this.gridOptions.data = _.unionBy(_.toArray(this.gridOptions.data), selectedAliases, 'partner.id');
        if (_.size(this.gridOptions.data) > originalGridDataSize) {
            this.editorForm.$setDirty();
        }
        this.loadingIndicator.show = false;
    };

    this.removeAlias = () => {
        const selectedAliases = this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected alias(es)?',
            pullCancelLeft: true,
            title: 'Remove Alias(es)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {

            this.gridOptions.data = _.differenceBy(this.gridOptions.data, selectedAliases, 'partner.id');
            this.editorForm.$setDirty();
        });
    };
    this.addAlias = () => {
        ModalService.showAliasesModal(addAliasHandler);
    };
    const columnDefinitions = [
        {
            field: 'partner.name',
            displayName: 'Partner (Read-Only)',
            cellEditableCondition: false,
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'alias',
            displayName: 'Alias (Double Click to Edit)',
            cellTemplate: 'components/visual/grid/inline-edit-template.html'
        }
    ];
    this.roleTypes = [
        'Audio',
        'Video',
        'CC',
        'Subtitle'
    ];

    this.gridOptions = {
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        enableCellEditOnFocus: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.edit.on.afterCellEdit(
                null,
                (rowEntity: JS5Object, colDef: JS5Object, newValue: any, oldValue: any) => {
                    if (newValue !== oldValue) {
                        _.set(rowEntity, 'edited', true);
                    }
                });
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };


    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && !!_.get(this.editData, 'name')
                && !!_.get(this.editData, 'type')
                && _.every(this.gridOptions.data, (gridItem: JS5Object) => {
                    return _.size(gridItem.alias);
                }),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(RolesService.originalEditData);
                this.gridOptions.data = _.get(this.editData, 'aliases');
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/properties/search`).search({
                tab: 'Roles',
                subTab: _.get(this.editData, 'type')
            })
        }
    ];

    this.$onInit = () => {
        SidebarService.editService = RolesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                getData();
            } else {
                this.allowRoleTypeEdit = _.isNil(_.get($routeParams, 'type'));
                if (!this.allowRoleTypeEdit) {
                    _.set(this.editData, 'type', _.get($routeParams, 'type'));
                }
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Role',
                    location: '/system/properties/search',
                    params: this.allowRoleTypeEdit ? {tab: 'Roles'} : {
                        tab: 'Roles',
                        subTab: _.get($routeParams, 'type')
                    }
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        RolesService.originalEditData = null;
        RolesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            RolesService.editorForm = this.editorForm;
            BreadcrumbService.editService = RolesService;
        });
    };
}


angular.module('prism-ui.roles').component('rolesEditView', {
    templateUrl: 'system/roles/editor/roles-edit-view-template.html',
    controller: RolesEditViewController,
    bindings: {
    }
});
